import { rem } from 'polished';
import styled, { css } from 'styled-components';

const inputCss = css<{ isMobile?: boolean; showError?: boolean }>`
  display: block;
  width: 100%;
  background: ${({ theme }) => theme.color.white};
  padding: ${rem(16)};
  height: ${rem(56)};
  max-width: ${({ isMobile }) => (isMobile ? 'initial' : rem(450))};
  font-size: ${rem(16)};
  color: ${({ theme }) => theme.colors.textPrimary};
  font-weight: 400;
  font-family: ${({ theme }) => theme.font.primary};
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.08);
  border: ${rem(1)} solid
    ${({ showError }) => (showError ? '#FF2D58' : '#cccccc')};
  border-radius: ${rem(4)};

  &:disabled {
    cursor: not-allowed;
  }

  &::placeholder {
    font-family: ${({ theme }) => theme.font.secondary};
    color: ${({ theme }) => theme.colors.placeholder};
    font-weight: 300;
  }

  &:read-only {
    color: ${({ theme }) => theme.colors.placeholder};
    background-color: #9999991c;
    outline: none;
  }

  &:-moz-read-only {
    color: ${({ theme }) => theme.colors.placeholder};
    background-color: #9999991c;
    outline: none;
  }

  ${({ theme }) => theme.mediab.m810`
    font-size: ${rem(14)};
    height: ${rem(40)};
  `}

  ${({ theme }) => theme.mediab.s450`
    max-width: initial;
    min-width: ${rem(65)};
  `}
`;

const Input: any = styled.input<{ maxWidth?: number }>`
  ${inputCss}
  max-width: ${({ maxWidth }) => (maxWidth ? rem(maxWidth) : 'initial')};
`;

const TextArea: any = styled.textarea`
  ${inputCss};
  resize: none;
`;

export { TextArea as DsiTextArea, Input as DsiInput };
